module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_Badges_116x116_3-75176ddfe8f7987407e101a3a3a84bee.png";